import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { TestimonialsStrip } from './components/TestimonialsStrip';
import { PainPoints } from './components/PainPoints';
import { SolutionReveal } from './components/SolutionReveal';
import { VolumesSection } from './components/VolumesSection';
import { ToolsSection } from './components/ToolsSection';
import { BonusSection } from './components/BonusSection';
import { UrgencySection } from './components/UrgencySection';
import { PricingSection } from './components/PricingSection';
import { ExtendedTestimonials } from './components/ExtendedTestimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
const META_PIXEL_ID = '1572798794523722';
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    const w = window as any;
    try {
      if (!w.fbq) {
        const pixel: any = w.fbq = function () {
          pixel.callMethod ? pixel.callMethod.apply(pixel, arguments) : pixel.queue.push(arguments);
        };
        if (!w._fbq) w._fbq = pixel;
        pixel.push = pixel;
        pixel.loaded = true;
        pixel.version = '2.0';
        pixel.queue = [];
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        const target = document.head || document.body || document.documentElement;
        if (target) target.appendChild(script);
        w.fbq('init', META_PIXEL_ID);
      }
      w.fbq('track', 'PageView');
    } catch (error) {
      console.warn('Meta Pixel initialization failed:', error);
    }
  }, []);
  return <div className="min-h-screen w-full bg-ivory text-ink selection:bg-gold/30 selection:text-brand" data-id="element-0" data-mp="nw2e2bl1k0tq">
      <main data-id="element-1" data-mp="stuexv3nyxa2">
        <Hero data-id="element-2" data-mp="stkok6epio3u" />
        <TestimonialsStrip data-id="element-3" data-mp="st2iyj65mxj9" />
        <PainPoints data-id="element-4" data-mp="swgmhuqk1csa" />
        <SolutionReveal data-id="element-5" data-mp="3686fj9n0kvj" />
        <VolumesSection data-id="element-6" data-mp="35gmj5pekbl3" />
        <ToolsSection data-id="element-7" data-mp="34napqbl6vw3" />
        <BonusSection data-id="element-8" data-mp="38b66v0ldsdg" />
        <UrgencySection data-id="element-9" data-mp="3udawu8hnin4p" />
        <PricingSection data-id="element-10" data-mp="3ubriinfk2m5k" />
        <ExtendedTestimonials data-id="element-11" data-mp="3ucjdbw1bwfus" />
        <Guarantee data-id="element-12" data-mp="d4o0nv3yoa99" />
        <FAQ data-id="element-13" data-mp="d4xp3e9cy9cu" />
        <FinalCTA data-id="element-14" data-mp="d3mmhhrnf7nb" />
      </main>
      <Footer data-id="element-15" data-mp="d3waizt4v4qd" />
    </div>;
}